import { message } from 'antd';
import { deleteWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

export const deleteCredential = async (id: number, refetch?: () => void) => {
  console.log('deleteCredential id', id);
  if (!id) return;

  try {
    const response = await deleteWithCSRF(envApiUrl + '/credentials/', {
      headers: {
        id,
      },
    });
    console.log('deleteCredential: response: ', response);
    message.success('Successfully deleted credential');
    refetch?.();
    return response.data;
  } catch (err: any) {
    console.error('deleteCredential error: ', err.response?.data?.message, err.response);
    message.error(err.response?.data?.message || 'Failed to delete credential');
  }
};
